import React from 'react';
import inventory from "../assets/inventory-icon.jpeg";
import stores from "../assets/customers.jpeg";
import dashboard from "../assets/dashboard-icon.jpeg";
import routes from "../assets/map-icon.jpeg";
import reports from "../assets/reports-icon.jpeg";
import orders from "../assets/orders-icon.jpeg";
import settings from "../assets/settings-icon.jpeg";
import billing from "../assets/billing-icon.jpeg"


const features = [
  {
    title: "Effortless Inventory Control",
    description: "Track stock levels, batch details, and monitor real-time inventory flow with precision.",
    icon: inventory,
  },
  {
    title: "Actionable Dashboard Insights",
    description: "Visualize your business performance with real-time analytics and key metrics at a glance.",
    icon: dashboard,
  },
  {
    title: "Seamless Route & Dropper Tracking",
    description: "Optimize delivery operations with live tracking and efficient route management.",
    icon: routes,
  },
  {
    title: "Comprehensive Customer Management",
    description: "Organize customer and store profiles with detailed purchase histories for better service.",
    icon: stores,
  },
  {
    title: "Unlimited Report Generation",
    description: "Generate in-depth reports like sales, stock, and customer analysis effortlessly.",
    icon: reports,
  },
  {
    title: "Streamlined Order Processing",
    description: "Simplify order management and ensure accurate, timely order fulfillment.",
    icon: orders,
  },
  {
    title: "Automated Billing Solutions",
    description: "Generate bills instantly with auto-calculated totals for a seamless checkout experience.",
    icon: billing,
  },
  {
    title: "Customizable Settings",
    description: "Tailor the platform to your business needs with flexible and intuitive settings.",
    icon: settings,
  },
];


const FeaturesSection = () => {

  return (
    <section className="bg-lightGray py-12" id="featuressss">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold text-navy text-center" data-aos="fade-up">Unlock Success with INVETIX</h2>
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 text-center"
              data-aos="zoom-in" // Animation for each feature box
            >
              <img src={feature.icon} width={120} alt={feature.title} className="mx-auto" />
              <h3 className="mt-4 font-bold text-navy">{feature.title}</h3>
              <p className="text-gray-700 mt-2">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
